module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Trading Plan","subtitlePrepend":"Trading Plan for","label":"Broker Account","subtitleAppend":"account","ctaUpgradeToPro":"With pro you can create unlimited trading plan."},"es":{"title":"Plan de Trading","subtitlePrepend":"Plan de Trading para","label":"Cuenta de Broker","subtitleAppend":"cuenta","ctaUpgradeToPro":"Con pro podrás crear ilimitados planes de trading."}}')
  delete Component.options._Ctor
}
